module.exports = __webpack_public_path__ + "img/avatar_white.2a6f60c3.png";